export interface tablaEjecutadas {
    id: string,
    Nombre: string;
    Fecha: string;
    Hora: string;
    Enviado: string;
    Estado: string;

    
  }
  
  export const TABLAEJECUTADAS: tablaEjecutadas[] = [
    {
      id: "1",
      Nombre: "INFORME DE VENCIMIENTOS DE DOCUMENTOS - VEHICULOS",
      Fecha: "2020-04-05",
      Hora: "00:00:00",
      Enviado: "onikaexpress@hotmail.com,dajovivas88@hotmail.com,comercial@ingenieriaydesarrollo.xyz",
      Estado: "EXITOSO",
    },

  ]